import { httpClient } from 'app/api/http/http-client';
import { useMutation } from 'react-query';
import { SelectCompanyResponseType } from 'app/utils/services/types/selectCompany.type';

const selectCompanyService = async (data: {
  data: { company_inn: string };
  url: string;
}): Promise<SelectCompanyResponseType> => {
  try {
    const result = await httpClient.post<SelectCompanyResponseType>(data.url, data.data);

    return result;
  } catch (err: any) {
    if (err?.response.status === 400) {
      return err?.response.data;
    }
  }
};

export const useSelectCompanyService = () => {
  const {
    isLoading: isLoadingSelectCompany,
    data: dataSelectCompany,
    mutate: selectCompanyMutation,
  } = useMutation(['selectCompany'], (data: { data: { company_inn: string }; url: string }) =>
    selectCompanyService(data)
  );

  return { isLoadingSelectCompany, dataSelectCompany, selectCompanyMutation };
};
